export const tr = {
    'strategy-description-avg-click': 'Belirttiğiniz kısıtlamalar dikkate alınarak maksimum tıklama alırsınız',
    'strategy-description-avg-cpa': "Yandex.Metrica'da belirtilen hedefe göre siteye maksimum hedef ziyaret alırsınız.",
    'strategy-description-default':
        'Teklif, bölge ve gösterimleri etkileyen diğer parametreleri kendiniz seçerek mümkün olan en yüksek gösterim sayısını elde edersiniz.',
    'strategy-description-roi':
        "Yatırım kârlılığını belirtilen seviyede tutarak Yandex.Metrica'da belirtilen hedefe göre maksimum hedef ziyaret sayısını elde edersiniz.",
    'strategy-name-avg-click': 'Tıklama optimizasyonu',
    'strategy-name-avg-cpa': 'Dönüşüm optimizasyonu',
    'strategy-name-default': 'Optimizasyonlu manuel teklif yönetimi',
    'strategy-name-roi': 'Kârlılık optimizasyonu'
};
